import styled, { keyframes } from 'styled-components'
import { COLORS } from 'consts/colors'

const BG_WIDTH = 200
const skeletonAnimation = keyframes`
  0% {
    background-position: ${BG_WIDTH}% 0; // keep aligned to bg size to prevent flickering
  }
  100% {
    background-position: -${BG_WIDTH}% 0;
  }
`

export const LoadingSkeleton = styled.div<{ $width?: number }>`
  width: ${({ $width }) => ($width ? `${$width}px` : '100%')};
  height: 100%;
  background: linear-gradient(
    90deg,
    ${COLORS.primaryLight} 0%,
    ${COLORS.white} 50%,
    ${COLORS.primaryLight} 100%
  );
  background-size: ${BG_WIDTH}% 100%;
  background-repeat: no-repeat;
  border-radius: 4px;
  border: 1px solid ${COLORS.primaryLight};
  animation: ${skeletonAnimation} 2s infinite linear;
`
